import styled from 'styled-components';
import TimeInput from 'js/components/core/form/TimeInput';

export default styled(TimeInput)`
  justify-self: center;
  align-self: center;
`;
